import {
  ApolloClient,
  gql,
  NormalizedCacheObject,
  useQuery,
} from '@apollo/client';
import {Query} from '../types/generated/graphql';

/**
 * Landing-page waitlist signups (admin-only). Newest first; the query is
 * `@admin`-gated server-side (a non-admin just gets a FORBIDDEN error).
 * cache-and-network so re-opening the tab paints the cached list instantly
 * then refreshes in the background.
 */
export const useWaitlistEntries = (
  client: ApolloClient<NormalizedCacheObject>,
  limit = 500,
) => {
  type T = Pick<Query, 'waitlistEntries'>;
  return useQuery<T, {limit: number}>(QUERY, {
    client,
    variables: {limit},
    fetchPolicy: 'cache-and-network',
  });
};

const QUERY = gql`
  query waitlistEntries($limit: Int!) {
    waitlistEntries(limit: $limit) {
      email
      source
      createdAt
      userAgent
    }
  }
`;
